import { render, staticRenderFns } from "./attachlog.vue?vue&type=template&id=35230ab9"
import script from "./attachlog.vue?vue&type=script&lang=js"
export * from "./attachlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports